(function () {
  function load(root) {
    var grid = root.querySelector('[data-recommendations-url]');
    if (!grid) return;

    fetch(grid.getAttribute('data-recommendations-url'))
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var fresh = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('.oddit-section-featured-collection__grid');
        if (!fresh) return;
        grid.innerHTML = fresh.innerHTML;
        // Injected cards miss the initial reveal pass, so show them immediately
        grid.querySelectorAll('.oddit-reveal').forEach(function (el) {
          el.classList.add('oddit-is-visible');
        });
      });
  }

  document.querySelectorAll('.oddit-section-featured-collection').forEach(load);

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.oddit-section-featured-collection');
    if (root) load(root);
  });
})();
